export default function () {
	return {
		location: '',
		show_popup: false,
		location_selected: this.$persist(false).using(sessionStorage),
		country_form: document.querySelector('.location-selector__form'),
		country_input: document.querySelector('.country_code'),

		selectLocation(country) {
			this.location_selected = true;
			this.country_input.value = country;
			const language = document.querySelector('.language_code');
			if (country === 'DE') {
				language.value = 'de';
			} else {
				language.value = 'en';
			}
			this.country_form.submit();
		},

		closePopup() {
			this.show_popup = false;
		},
		init() {
			this.$watch('location', () => {
				if (this.location === 'DE') {
					this.show_popup = false;
				} else {
					if (!this.location_selected) {
						setTimeout(() => {
							this.show_popup = true;
						}, 1000);
					}
				}
			});
		},
	};
}
